module.exports = __webpack_public_path__ + "img/wix_2.bcd637db.png";